<template>
  <div class="post-wrapper">
    <div class="post-content">
      <div>
        <h2>{{ post.title }}</h2>
        <p>{{ post.content }}</p>
        <!--
          This is where the link is selected for the focused-section
        -->
        <router-link class="link" :to="{ name: 'FocusedView', params: { id: post.title } }">
          Learn More
          <img
            src="@/assets/Icons/arrow-right-light.svg"
            alt="Right facing arrow"
            class="arrow"
          />
        </router-link>
      </div>
    </div>
    <div class="post-photo">
      <img :src="require(`../assets/images/${post.photo}.png`)" :alt="post.alt" />
    </div>
  </div>
</template>

<script>

export default {
  props: ['post'],
};
</script>

<style lang="scss" scoped>
.post-wrapper {
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  @media (min-width: 700px) {
    min-height: 650px;
    max-height: 650px;
    flex-direction: row;
  }

  .post-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 4;
    order: 2;
    @media(min-width: 700px) {
      order: 1;
    }
    @media(min-width: 800px) {
      flex: 3;
    }

    div {
      max-width: 375px;
      padding: 72px 24px;
      @media(min-width: 700px) {
        padding: 0 24px;
      }

      h2 {
        font-size: 32px;
        font-weight: 300;
        text-transform: uppercase;
        margin-bottom: 24px;
        @media(min-width: 700px) {
          font-size: 40px;
        }
      }

      p {
        font-size: 15px;
        font-weight: 300;
        line-height: 1.7;
      }

      .content-preview {
        font-size: 13px;
        max-height: 24px;
        width: 250px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .link {
        display: inline-flex;
        align-items: center;
        margin-top: 32px;
        padding-bottom: 4px;
        border-bottom: 1px solid transparent;
        transition: .5s ease-in all;

        &:hover {
          border-bottom-color: #015D87;
        }
      }

      .link-light {
        &:hover {
          border-bottom-color: #fff;
        }
      }
    }
  }

  .post-photo {
    order: 1;
    flex: 3;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    @media(min-width: 700px) {
      order: 2;
    }
    @media(min-width: 800px) {
      flex: 4;
    }

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &:nth-child(even) {
    .post-content {
      order: 2;
    }
    .post-photo {
      order: 1;
    }
  }
}
</style>
